import { createGlobalStyle, css, rem, screenMobilePlusAndBigger } from 'theme';

export const Headings = createGlobalStyle`
  h1, h2, h3, h4, h5 {
    font-family: var(--ref-font-family-diodrum),OpenSans,sans-serif;
    margin: 0;
    line-height: 2;
  }

  h1 {
    font-size: ${rem(28)};
    font-weight: var(--sys-font-weight-semibold);

    ${screenMobilePlusAndBigger(css`
      font-size: ${rem(32)};
      line-height: ${rem(44)};
    `)};
  }

  h2 {
    font-size: var(--ref-font-size-lg);
    margin: 0;
    font-weight: var(--sys-font-weight-semibold);

    ${screenMobilePlusAndBigger(css`
      font-size: ${rem(30)};
      line-height: ${rem(32)};
    `)};
  }

  h3 {
    font-size: ${rem(18)};
    font-weight: var(--sys-font-weight-semibold);

    ${screenMobilePlusAndBigger(css`
      font-size: ${rem(24)};
      line-height: ${rem(32)};
    `)}
  }

  h4 {
    font-size: var(--ref-font-size-lg);
    line-height: ${rem(24)};
    font-weight: var(--sys-font-weight-semibold);
  }

  h5 {
    font-size: var(--ref-font-size-md);
    margin: 0;
    font-weight: var(--sys-font-weight-semibold);

      ${screenMobilePlusAndBigger(css`
        font-size: ${rem(18)};
        line-height: ${rem(20)};
      `)};
  }
`;
